
export class UtmTrackerInfo {
    public companyCode!: string;
    public actionUrl!: string;
    public entity!: string;
    public entityId!: number;
    public utmMedium!: string;
    public utmSource!: string;
    public utmCampaign!: string;
    public utmTerm!: string;
    public utmContent!: string;
    public referralCode!: string;
    public jobPostingId!: number;

    public setUtmParams(queryParams: any) {
        this.utmMedium = queryParams.utm_medium;
        this.utmSource = queryParams.utm_source;
        this.utmCampaign = queryParams.utm_campaign;
        this.utmTerm = queryParams.utm_term;
        this.utmContent = queryParams.utm_content;
    }
}
